define('model/attachment.model',['require','exports','module','underscore','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
     BaseModel = require('fukit').BaseModel;

  var AttachmentModel = BaseModel.extend({
    useHalSelfLinkAsUrl: false,

    fetchSignedUrl: function(options) {
      var rootUrl = _.result(this, 'url');
      var signedUrlModel = new BaseModel();
      return signedUrlModel
        .fetch(
          _.extend(
            {
              url: rootUrl + '/fileLink',
            },
            options
          )
        )
        .promise()
        .then(function() {
           return signedUrlModel;
        })
        .catch(function(error) {
           console.error('An error occurred while fetching the signed URL:', error);
        });
    },
  });

  module.exports = AttachmentModel;
});

